/**
 * @file
 * Top-bar position on scroll functionality.
 */
import Headroom from "headroom.js";
/* eslint-disable-next-line import/no-extraneous-dependencies */
import _ from "lodash";

(($, { behaviors }) => {
  const topBar = document.querySelector(".js-top-bar");
  const headerHeight = $(topBar).height();
  const headroom = new Headroom(topBar, {
    offset: headerHeight,
    tolerance: {
      up: 5,
      down: 0,
    },
    classes: {
      // On scroll up.
      pinned: "top-bar--visible",
      // On scroll down.
      unpinned: "top-bar--hidden",
      // When above offset.
      top: "top-bar--at-top",
      // When below offset.
      notTop: "top-bar--not-at-top",
      // When at bottom of scoll area.
      bottom: "top-bar--at-bottom",
      // When not at bottom of scroll area.
      notBottom: "top-bar--not-at-bottom",
    },
  });
  /**
   * Initiate top-bar scroll behavior with the 'Headroom' jQuery plugin that
   * is used to alter top-bar classes depending on user scroll behavior.
   */
  function initiateHeaderScrollBehavior() {
    if (topBar === null) return;
    headroom.init();
  }

  /**
   * Disables top-bar scroll behavior by inactivating the 'Headroom' jQuery
   * plugin.
   */
  function disableHeaderScrollBehavior() {
    headroom.destroy();
  }

  /**
   * Initiates or disables top-bar scroll behaviour.
   *
   * @param {onWindowResizeAndLoad~requestCallback} cb
   *   The callback that handles the response.
   * @param {number} debounceTime
   *   Duration after which the function is run.
   */
  function onWindowResizeAndLoad(cb, debounceTime = 250) {
    const $window = $(window);
    $window.on(
      "resize",
      _.debounce(() => {
        cb();
      }, debounceTime)
    );
    cb();
  }

  /**
   * Attaches behaviors for top-bar position on scroll.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches top-bar position on scroll functionality.
   */
  behaviors.topBarPositionOnScroll = {
    attach() {
      const $searchToggle = $(".js-search-toggle");
      const breakpointLarge = "(min-width: 1100px)";
      onWindowResizeAndLoad(() => {
        if (window.matchMedia(breakpointLarge).matches) {
          initiateHeaderScrollBehavior();
        } else {
          disableHeaderScrollBehavior();
        }
      });

      onWindowResizeAndLoad(() => {
        if (window.matchMedia(breakpointLarge).matches) {
          $searchToggle.on(
            "click",
            _.debounce(() => {
              initiateHeaderScrollBehavior();
            }, 150)
          );
        }
      });
    },
  };
})(jQuery, Drupal);
